// RowComponent.tsx (example)
import { TableCell } from "@mui/material";
import { useState, useEffect } from 'react'; 

const RowComponent = ({
  row,
  count,
  tableHeader,
  stickyFirstColumnEnabled,
  index,
  selectableRows,
  firstColMeta
}) => {
  const [firstHeader, setFirstHeader] = useState([]); 
  const [restHeaders, setRestHeaders] = useState([]); 

  const stickySx = stickyFirstColumnEnabled
    ? {
        position: "sticky",
        left: 0,
        zIndex: 1, // keep above scrolled content
        backgroundColor: "background.paper", // prevent overlap artifacts
      }
    : {};

  useEffect(() => {
    if (tableHeader){
      // Order headers by columnorder (fallback to natural order)
      const orderedHeaders = [...tableHeader].sort(
        (a, b) => (a.columnorder ?? 0) - (b.columnorder ?? 0)
      );
      setFirstHeader(orderedHeaders[0]);
      setRestHeaders(orderedHeaders.slice(1));
    }
  }, [tableHeader]); 

  // useEffect(() => {
  //   console.log(firstHeader); 
  // }, [firstHeader]); 
  // useEffect(() => {
  //   console.log(restHeaders); 
  // }, [restHeaders]); 
  // useEffect(() => {
  //   console.log(firstColMeta); 
  // }, [firstColMeta]); 

  return (
    <>
      {/* FIRST COLUMN: render only for the first row in a group */}
      {firstHeader && firstColMeta?.isFirst && (
        <TableCell
          rowSpan={firstColMeta.span}
          className={stickyFirstColumnEnabled ? "table-cell-sticky" : ""}
          sx={stickySx}
        >
          {/* Adjust this rendering as needed (formatters, components, etc.) */}
          {String(row[firstHeader.columnname] ?? "")}
        </TableCell>
      )}
      {/* OTHER COLUMNS: render for every row */}
      {restHeaders.map((h) => (
        <TableCell key={h.columnname}>
          {String(row[h.columnname] ?? "")}
        </TableCell>
      ))}
    </>
  );
};

export default RowComponent; 